export default __webpack_public_path__ + "static/giotto-plus-3-b74009d9f10b10dd77f8e76e1dfc40e4.jpg";